export const STATUS_PENDING = "Pending";
export const STATUS_DIDNOT = "Didnot";
export const STATUS_HIRED = "Hired";